import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import DOMPurify from 'dompurify';

import { programBoardDetail, programBoardList } from '@/network/apis/apiUri';

export const useListQeury = () => {
  const location = useLocation();
  const params = useParams();
  const mode = useSelector((state) => state.mode);

  const listQuery = (pageParam) => {
    const { programCode = location.pathname.split('/')[2], boardId = location.pathname.split('/')[4] } = params;

    const search = new URLSearchParams(location.search);

    const page = pageParam ?? search.get('page') ?? 1;
    const searchOption = search.get('searchOpt');
    const searchValue = search.get('searchText') ?? '';

    return {
      queryKey: ['program', programCode, 'photo-gallery', boardId, { page, searchOption, searchValue }, mode],
      queryFn: async () => {
        const response = await programBoardList({
          board_id: boardId ?? location.pathname.split('/')[4],
          lan_code: mode,
          reg_order: 'desc',
          key_word: searchValue ? searchOption : null,
          word: searchValue,
          page_info: {
            row_count: 8,
            number: page - 1,
          },
        });
        return {
          items: response.data.item.map((item) => ({
            photoId: item.board_item_id,
            title: item.title,
            thumbnail: item.image.url,
            content: DOMPurify.sanitize(item.content),
            registDate: dayjs.tz(item.reg_date).format('YYYY-MM-DD'),
          })),
          currentPage: response.data.paging_info.number + 1,
          totalPages: response.data.paging_info.total_page_count,
        };
      },
      enabled: !!mode && !!boardId && !!programCode,
      staleTime: 1 * 60 * 1000,
      keepPreviousData: true,
      refetchOnMount: false,
    };
  };

  return listQuery;
};

export const useDetailQeury = () => {
  const location = useLocation();

  const detailQeury = (id) => {
    const search = new URLSearchParams(location.search);

    const photoId = id ?? search.get('photoId') ?? null;

    return {
      queryKey: ['program', photoId],
      queryFn: async () => {
        const response = await programBoardDetail({
          board_item_id: photoId,
          hit: true,
        });

        return response.data;
      },
      enabled: !!photoId,
      retry: false,
      staleTime: 1 * 60 * 1000,
      refetchOnMount: false,
    };
  };
  return detailQeury;
};
